<script lang="ts">
    
    import { derived } from "svelte/store";
    import type { Readable, Writable } from "svelte/store";
    import type { State } from "../Model/State";

    type Store = State<any> | Writable<any> | Readable<any>;

    export let state: Store | Store[] = undefined;

    let value: Store;

    $: setupStore(state);

    function setupStore(state: Store | Store[]): void {
        if (!state) {
            value = undefined;
            return;
        }
        if (Array.isArray(state)) {
            value = derived(state, values => values);
        } else {
            value = state;
        }
    }

</script>

<slot value={$value}>{$value}</slot>

